export const ErrorsEnum = {
  Unauthorized: 401,
  ManyRequests: 429
}

export default ErrorsEnum
